import * as React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';

export const SearchOutSideClick = ({ outSideClick, children }) => {
  const { isMobile } = useDeviceDetect();
  if (isMobile) {
    return <div>{ children }</div>;
  }
  return <OutsideClickHandler onOutsideClick={outSideClick}>{children}</OutsideClickHandler>;
};
